import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import styled from 'styled-components'

import { toggleMinimizedApp } from '../../duck/operations'

import Image from '../shared/image'

import maximizeIcon from '../../assets/icons/maximize.svg'
import ampmeFullLogo from '../../assets/images/ampme-logo.png'

const Main = styled.div`
  position: relative;
  display: flex;
  border: 1px solid #f1f1f1;
  border-bottom: none;
  height: 72px;
  width: 180px;
  background-image: linear-gradient(224deg, #00fff2, #00b4fe);
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const Logo = styled(Image).attrs({
  src: ampmeFullLogo
})`
  width: 160px;
`

const MaximizeIconContainer = styled.div`
  position: absolute;
  right: 0px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  &:hover {
    background-color: rgba(204, 204, 204, 0.5);
  }
  &:active {
    opacity: 0.8;
  }
 `

const MaximizeIcon = styled(Image).attrs({
  src: maximizeIcon
})`
  border-radius: 50%;
`

export const MinimizedAppComponent = (props) => {
  return (
    <Main>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <MaximizeIconContainer>
        <MaximizeIcon
          onClick={props.toggleMinimizedApp}
        />
      </MaximizeIconContainer>
    </Main>
  )
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators( { toggleMinimizedApp }, dispatch)
}

export const MinimizedApp = connect(undefined, mapDispatchToProps)(MinimizedAppComponent)



// WEBPACK FOOTER //
// ./src/components/minimizedApp/minimizedApp.js